

import React from "react";

export const CloseIcon = ({fill = `#323D3E`}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={fill ? fill : "none"}
  >
    <path
      d="M0.718957 14.2194C0.649274 14.2891 0.594 14.3718 0.556288 14.4629C0.518576 14.5539 0.499165 14.6515 0.499165 14.7501C0.499165 14.8486 0.518576 14.9462 0.556288 15.0372C0.594 15.1283 0.649274 15.211 0.718957 15.2807C0.78864 15.3504 0.871366 15.4056 0.96241 15.4433C1.05345 15.4811 1.15104 15.5005 1.24958 15.5005C1.34813 15.5005 1.44571 15.4811 1.53675 15.4433C1.6278 15.4056 1.71052 15.3504 1.78021 15.2807L7.99958 9.06036L14.219 15.2807C14.3597 15.4214 14.5506 15.5005 14.7496 15.5005C14.9486 15.5005 15.1395 15.4214 15.2802 15.2807C15.4209 15.1399 15.5 14.9491 15.5 14.7501C15.5 14.551 15.4209 14.3602 15.2802 14.2194L9.0599 8.00005L15.2802 1.78068C15.4209 1.63995 15.5 1.44907 15.5 1.25005C15.5 1.05103 15.4209 0.860156 15.2802 0.719426C15.1395 0.578695 14.9486 0.499634 14.7496 0.499634C14.5506 0.499634 14.3597 0.578695 14.219 0.719426L7.99958 6.93974L1.78021 0.719426C1.63948 0.578695 1.44861 0.499634 1.24958 0.499634C1.05056 0.499634 0.859688 0.578695 0.718957 0.719426C0.578226 0.860156 0.499165 1.05103 0.499165 1.25005C0.499165 1.44907 0.578226 1.63995 0.718957 1.78068L6.93927 8.00005L0.718957 14.2194Z"
      fill={fill ? fill : "#323D3E"}
      
    />
  </svg>
);


export const PlusIcon = ({type}) => (
    <svg className={type} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M1 7H13M7 1V13" stroke="#323D3E" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>  
);

export const MinusIcon = ({type}) => (
    <svg className={type} xmlns="http://www.w3.org/2000/svg" width="14" height="2" viewBox="0 0 14 2" fill="none">
        <path d="M1 1H13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    </svg> 
);

export const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
        <path d="M2.83398 4.16665H11.1673V5.83331H2.83398V4.16665ZM0.333984 0.833313H13.6673V2.49998H0.333984V0.833313ZM5.33398 7.49998H8.66732V9.16665H5.33398V7.49998Z" fill="#748B85"/>
    </svg>
);

export const ChevronDownIcon = ({type}) => (
<svg className={type} xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
  <path d="M1.34961 1.20001L7.04961 6.80001L12.6498 1.20001" stroke="#748B85" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);